import { useRef } from 'react';
import './Missionmv.css';
import missionVideo from '../assets/mission.mp4';

const Missionmv = () => {
  const videoRef = useRef(null);

  // 動画終了時の処理（必要なら）
  const handleVideoEnd = () => {
    console.log('動画再生が終了しました');
  };

  const handleVideoError = (e) => {
    console.error('動画の読み込みエラー:', e);
  };

  return (
    <section 
      id="mission"
      className="missionmv-section"
    >
      <div className="missionmv-container">
        <video
          ref={videoRef}
          className="missionmv-video"
          muted
          autoPlay
          loop
          playsInline
          preload="metadata"
          onEnded={handleVideoEnd}
          onError={handleVideoError}
        >
          <source src={missionVideo} type="video/mp4" />
          お使いのブラウザは動画をサポートしていません。
        </video>
      </div>
    </section>
  );
};

export default Missionmv;
